


































import Vue from 'vue';
import { debounce } from 'lodash';

import { ValidationObserver } from 'vee-validate';

export default Vue.extend({
  name: 'HMEmbedImageModal',
  components: {
    ValidationObserver,
  },
  data() {
    return {
      imageUrl: '',
      isValidImage: false,
    };
  },
  methods: {
    handleOnInput(value) {
      this.imageUrl = value;
      this.isValidImage = false;
      this.checkImage();
    },
    checkImage: debounce(async function () {
      const img = new Image();
      img.src = this.imageUrl;
      img.onload = () => {
        this.isValidImage = true;
        this.$refs.form.setErrors({});
      };
      img.onerror = () => {
        this.isValidImage = false;
        this.$refs.form.setErrors({
          'image-url': [this.$t('GENERAL.ERROR.NOT_A_VALID_IMAGE_URL')],
        });
      };
    }, 400),
    selectImageUrl() {
      this.$parent.$emit('selectImageUrl', this.imageUrl);
      this.$emit('close');
    },
  },
});
